import React from 'react';
import { Modal } from 'antd';
import CategoryForm from './CategoryForm';

const CategoryModal = ({
  visible,
  onCancel,
  onSubmit,
  initialValues,
  title,
  categories = [],
}) => {
  return (
    <Modal
      title={title || 'Add Category'}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={800}
    >
      <CategoryForm
        initialValues={initialValues}
        onSubmit={(values) => {
          onSubmit(values);
          onCancel();
        }}
        onCancel={onCancel}
        categories={categories}
      />
    </Modal>
  );
};

export default CategoryModal;
